//Configuracion columnas Tracking
export const columnsTracking = [
  { CAMPODES: "DO", NOMCOLXX: "MDOSYYYY.DOCNROXX", SHOWCOLX: "SI", CAMPKEYX: "SI", CENTERXX: true },
  { CAMPODES: "Pedido", NOMCOLXX: "MDOSYYYY.DOIPEDXX", SHOWCOLX: "SI", CAMPKEYX: "SI", CENTERXX: true },
  {
    CAMPODES: "Cliente",
    NOMCOLXX: "CIPO0024.CLINOMCX",
    SHOWCOLX: "SI",
    CAMPKEYX: "SI",
    CENTERXX: true,
  },
  {
    CAMPODES: "Línea de Negocio",
    NOMCOLXX: "CIPO0119.LINEDESX",
    SHOWCOLX: "NO",
    CAMPKEYX: "NO",
    SELECTXX: "NO",
    CENTERXX: true,
  },
  {
    CAMPODES: "Sucursal",
    NOMCOLXX: "MDOSYYYY.SUCIDXXX",
    SHOWCOLX: "NO",
    CAMPKEYX: "NO",
    SELECTXX: "NO",
    CENTERXX: true,
  },
  {
    CAMPODES: "Medio de transporte",
    NOMCOLXX: "CIPO0013.MTRDESXX",
    SHOWCOLX: "NO",
    CAMPKEYX: "NO",
    SELECTXX: "NO",
    CENTERXX: true,
  },
  {
    CAMPODES: "Documento de transporte",
    NOMCOLXX: "MDOSYYYY.DOCTRIMP",
    SHOWCOLX: "SI",
    CAMPKEYX: "SI",
    CENTERXX: true,
  },
  {
    CAMPODES: "Deposito",
    NOMCOLXX: "CIPO0117.DEPDESXX",
    SHOWCOLX: "NO",
    CAMPKEYX: "NO",
    SELECTXX: "NO",
    CENTERXX: true,
  },
  {
    CAMPODES: "Coordinador de cuenta",
    NOMCOLXX: "CUENTNOM",
    SHOWCOLX: "NO",
    CAMPKEYX: "NO",
    SELECTXX: "NO",
    CENTERXX: true,
  },
  {
    CAMPODES: "Coordinador de operaciones",
    NOMCOLXX: "OPERANOM",
    SHOWCOLX: "NO",
    CAMPKEYX: "NO",
    SELECTXX: "NO",
    CENTERXX: true,
  },
  {
    CAMPODES: "Tipo de declaración",
    NOMCOLXX: "MDOSYYYY.DOCTIPDE",
    SHOWCOLX: "NO",
    CAMPKEYX: "NO",
    SELECTXX: "NO",
    CENTERXX: true,
  },
  {
    CAMPODES: "Estado de facturación",
    NOMCOLXX: "CIPF0051.ESTAFADE",
    SHOWCOLX: "NO",
    CAMPKEYX: "NO",
    SELECTXX: "NO",
    CENTERXX: true,
  },
  {
    CAMPODES: "Usuario Modificación ",
    NOMCOLXX: "USRNOMMD",
    SHOWCOLX: "SI",
    CAMPKEYX: "SI",
    SELECTXX: "NO",
    CENTERXX: true,
  },
  {
    CAMPODES: "Fecha modificacion",
    NOMCOLXX: "MDOSYYYY.REGFECMX",
    SHOWCOLX: "SI",
    CAMPKEYX: "SI",
    SELECTXX: "NO",
    CENTERXX: true,
  },
  {
    CAMPODES: "Hora Modificación",
    NOMCOLXX: "MDOSYYYY.REGHORMX",
    SHOWCOLX: "SI",
    CAMPKEYX: "SI",
    SELECTXX: "NO",
    CENTERXX: true,
  },
  { CAMPODES: "Estado", NOMCOLXX: "MDOSYYYY.REGESTXX", SHOWCOLX: "NO", CAMPKEYX: "NO", CENTERXX: true },
  {
    CAMPODES: "Cantidad Controladores",
    NOMCOLXX: "COTRLLER",
    SHOWCOLX: "NO",
    CAMPKEYX: "NO",
    SELECTXX: "NO",
    CENTERXX: true,
    ISLINKXX: true,
  },
];

//Configuracion para la columnas que manejsa color en sus valores
export const settingsColorStatus = [
  {
    title: "ESTGEDES",
    params: [
      { value: "Alta", color: "secondary-500" },
      { value: "Media", color: "primary-600" },
      { value: "Baja", color: "success-400" },
    ],
  },
];

export const columnsConsult = [
  {
    CAMPODES: "Cliente",
    NOMCOLXX: "MDOSYYYY.CLIIDXXX",
    TIPCAMXX: "SELECCION",
    FUNCTION: "getClientById",
    OPTIONSX: [],
  },
  {
    CAMPODES: "Usuario Creación",
    NOMCOLXX: "MDOSYYYY.REGUSRXX",
    TIPCAMXX: "SELECCION",
    FUNCTION: "getUserById",
    OPTIONSX: [],
  },
  {
    CAMPODES: "Estado",
    NOMCOLXX: "MDOSYYYY.REGESTXX",
    TIPCAMXX: "SELECCION",
    FUNCTION: "",
    OPTIONSX: [
      { value: "", label: "SELECCIONE" },
      { value: "ACTIVO", label: "ACTIVO" },
      { value: "INACTIVO", label: "INACTIVO" },
      { value: "FACTURADO", label: "FACTURADO" },
    ],
  },

  { CAMPODES: "Fecha de Creación", NOMCOLXX: "MDOSYYYY.REGFECXX", TIPCAMXX: "FECHA", FUNCTION: "" },
  { CAMPODES: "Fecha de Modificación", NOMCOLXX: "MDOSYYYY.REGFECMX", TIPCAMXX: "FECHA", FUNCTION: "" },
  {
    CAMPODES: "Resultado Clave",
    NOMCOLXX: "MDOBYYYY.RESCLAXX",
    TIPCAMXX: "SELECCION",
    FUNCTION: "getKeyResultsById",
    OPTIONSX: [],
  },
  {
    CAMPODES: "Controladores Asociados",
    NOMCOLXX: "MDCOYYYY.USRIDXXX",
    TIPCAMXX: "SELECCION",
    FUNCTION: "getUserById",
    OPTIONSX: [],
  },
];

export const columnsExport = [
  { CAMPODES: "DO", NOMCOLXX: "MDOSYYYY.DOCNROXX" },
  { CAMPODES: "Tarea vs Do", NOMCOLXX: "TASKXDOX" },
  { CAMPODES: "Estado", NOMCOLXX: "MDOSYYYY.REGESTXX" },
  { CAMPODES: "Cliente", NOMCOLXX: "CIPO0024.CLINOMCX" },
  { CAMPODES: "Coordinador de cuenta", NOMCOLXX: "CUENTNOM" },
  { CAMPODES: "Director de cuenta", NOMCOLXX: "DIRCUENT" },
  { CAMPODES: "Modo de Transporte", NOMCOLXX: "MTRDESXX" },
  { CAMPODES: "Sucursal", NOMCOLXX: "SUCDESXX" },
  { CAMPODES: "Pedido", NOMCOLXX: "MDOSYYYY.DOIPEDXX" },
  { CAMPODES: "Usuario Creación ", NOMCOLXX: "USRNOMCR" },
  { CAMPODES: "Fecha de Creación", NOMCOLXX: "MDOSYYYY.REGFECXX" },
  { CAMPODES: "Hora de Creación", NOMCOLXX: "MDOSYYYY.REGHORXX" },
  { CAMPODES: "Usuario Modificación ", NOMCOLXX: "USRNOMMD" },
  { CAMPODES: "Fecha Modificación", NOMCOLXX: "MDOSYYYY.REGFECMX" },
  { CAMPODES: "Hora Modificación", NOMCOLXX: "MDOSYYYY.REGHORMX" },
  { CAMPODES: "Cantidad Controladores", NOMCOLXX: "COTRLLER" },
  { CAMPODES: "Controladores Asociados", NOMCOLXX: "USRCTRLX" },
];

// Configuración de colores para estados para la Creacion del DO
export const settingsColorCreateDoStatus = [
  {
    title: "SAFAESTX",
    params: [
      { value: "PENDIENTE", color: "neutral-400" },
      { value: "CON SALDO", color: "success-400" },
      { value: "SIN SALDO", color: "error-400" },
    ],
  },
];

// Configuración de columnas para Creacion del DO
export const columnsSoporteValor = [
  {
    CAMPODES: "Nro Doc. Soporte de Valor",
    NOMCOLXX: "FACIDXXX",
    SHOWCOLX: "SI",
    CAMPKEYX: "SI",
    CENTERXX: true,
    SELECTXX: "SI",
  },
  {
    CAMPODES: "Fecha Doc. Soporte de Valor",
    NOMCOLXX: "FACFECXX",
    SHOWCOLX: "SI",
    CAMPKEYX: "SI",
    CENTERXX: true,
  },
  {
    CAMPODES: "Cliente",
    NOMCOLXX: "CLINOMXX",
    SHOWCOLX: "SI",
    CAMPKEYX: "NO",
    CENTERXX: true,
  },
  {
    CAMPODES: "Proveedor",
    NOMCOLXX: "PRORAZXX",
    SHOWCOLX: "SI",
    CAMPKEYX: "NO",
    CENTERXX: true,
  },
  {
    CAMPODES: "Término de Negociación",
    NOMCOLXX: "TERMIDXX",
    SHOWCOLX: "SI",
    CAMPKEYX: "SI",
    CENTERXX: true,
  },
  {
    CAMPODES: "Moneda",
    NOMCOLXX: "MONIDXXX",
    SHOWCOLX: "SI",
    CAMPKEYX: "SI",
    CENTERXX: true,
  },
  {
    CAMPODES: "Estado",
    NOMCOLXX: "SAFAESTX",
    SHOWCOLX: "SI",
    CAMPKEYX: "SI",
    SELECTXX: "SI",
    CENTERXX: true,
  },
];

// Configuración de columnas para Documento de Transporte
export const columnsTransporte = [
  {
    CAMPODES: "Nro. Doc de Transporte",
    NOMCOLXX: "DTRCDOTR",
    SHOWCOLX: "SI",
    CAMPKEYX: "SI",
    CENTERXX: true,
  },
  {
    CAMPODES: "Fecha Estimada de Arribo",
    NOMCOLXX: "DTTIFEES",
    SHOWCOLX: "SI",
    CAMPKEYX: "SI",
    CENTERXX: true,
  },
  {
    CAMPODES: "Jurisdicción Aduanera",
    NOMCOLXX: "JURISDICCION",
    SHOWCOLX: "SI",
    CAMPKEYX: "SI",
    CENTERXX: true,
  },
  {
    CAMPODES: "Medio de Transporte",
    NOMCOLXX: "DTRCMETR",
    SHOWCOLX: "SI",
    CAMPKEYX: "SI",
    CENTERXX: true,
  },
  {
    CAMPODES: "Transportadora",
    NOMCOLXX: "TRANSPORTADORA",
    SHOWCOLX: "SI",
    CAMPKEYX: "SI",
    CENTERXX: true,
  },
  {
    CAMPODES: "Peso",
    NOMCOLXX: "PESO",
    SHOWCOLX: "SI",
    CAMPKEYX: "SI",
    CENTERXX: true,
  },
  {
    CAMPODES: "Piezas",
    NOMCOLXX: "PIEZAS",
    SHOWCOLX: "SI",
    CAMPKEYX: "SI",
    CENTERXX: true,
  },
  {
    CAMPODES: "Depósito",
    NOMCOLXX: "DEPDESXX",
    SHOWCOLX: "SI",
    CAMPKEYX: "SI",
    CENTERXX: true,
  },
  {
    CAMPODES: "Estado",
    NOMCOLXX: "DOCTRAES",
    SHOWCOLX: "SI",
    CAMPKEYX: "SI",
    SELECTXX: "NO",
    CENTERXX: true,
  },
]

export const settingsColorStatusTransporte = [
  {
    title: "DOCTRAES",
    params: [
      { value: "CON SALDO", color: "success-400" },
      { value: "PENDIENTE", color: "neutral-400" },
      { value: "SIN SALDO", color: "error-400" },
    ],
  },
]
